import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

const apiUrl = environment.rapi;

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private _httpService: HttpClient) {}

  getCountries() {
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Accept: 'application/json'
      }
    };
    return this._httpService.get(`${apiUrl}/api/countries`, httpOptions);
  }
}
